// =====================================================================
// tpCustomer — MEDDPICCR / forecast thresholds
//
// Pure module. Consolidates four threshold values that the build spec
// (P2.2) calls out as scattered hard-coded literals — they all now read
// from settings.meddpiccThresholds with the fallback defaults below.
//
// Sources before this module landed:
//   STAGE_FORECAST_MIN     tpCustFe/pages/opportunities.jsx:29-35
//   forecast commit-ready  tpCustFe/pages/forecast.jsx:93
//   forecast at-risk       tpCustFe/pages/forecast.jsx:107
//   dashboard "≥6"         tpCustFe/pages/sales-dashboard.jsx:166
//
// confidenceMin (P1.1) is also under meddpiccThresholds; see
// opportunity-meddpiccr.js for that reader. Keeping both readers in
// their own files keeps the score-derivation logic separate from the
// forecast-threshold logic.
// =====================================================================

(function () {
  'use strict';

  function intOr(v, fallback) {
    return Number.isInteger(v) ? v : fallback;
  }

  // Returns the four threshold integers with defaults. Pure: no D, no
  // window. Pass settings explicitly so the test harness can drive it.
  function meddpiccForecastThresholds(settings) {
    var t = (settings && settings.meddpiccThresholds) || {};
    return {
      bestCase:    intOr(t.bestCase,    4),
      commit:      intOr(t.commit,      6),
      closed:      intOr(t.closed,      7),
      atRiskBelow: intOr(t.atRiskBelow, 4),
    };
  }

  // Returns the map keyed by forecastCategory name — what the existing
  // STAGE_FORECAST_MIN literal looked like, so the call site swap is a
  // one-line change. Pipeline is always 0 (no MEDDPICCR floor).
  function stageForecastMin(settings) {
    var t = meddpiccForecastThresholds(settings);
    return {
      Pipeline:    0,
      'Best case': t.bestCase,
      Commit:      t.commit,
      Closed:      t.closed,
    };
  }

  if (typeof window !== 'undefined') {
    window.tpThresholds = {
      meddpiccForecastThresholds: meddpiccForecastThresholds,
      stageForecastMin: stageForecastMin,
    };
  }
})();
